import { ContentPage } from '../page-factory/content-page';
import { paushPurnimaPage } from '../pages/page-kumbh-2025.paush-purnima';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(paushPurnimaPage);

export default function PaushPurnimaPage() {
  return <ContentPage {...paushPurnimaPage} />;
}
